import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  DateField,
  BooleanField,
  EditButton,
  ShowButton,
  DeleteButton,
  Filter,
  SearchInput,
  SelectInput,
  TopToolbar,
  CreateButton,
  ExportButton,

  FunctionField,
} from 'react-admin';

const UserFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <SelectInput
      source="telegramLinked"
      choices={[
        { id: true, name: 'Да' },
        { id: false, name: 'Нет' },
      ]}
      label="Telegram подключен"
    />
    <SelectInput
      source="walletAddress"
      choices={[
        { id: 'exists', name: 'Есть кошелек' },
        { id: 'not_exists', name: 'Нет кошелека' },
      ]}
      label="Статус кошелька"
    />
  </Filter>
);

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export const UserList = () => (
  <List
    filters={<UserFilter />}
    actions={<ListActions />}
    sort={{ field: 'createdAt', order: 'DESC' }}
    perPage={25}
  >
    <Datagrid>
      <TextField source="id" label="ID" />
      <TextField source="name" label="Имя" />
      <EmailField source="email" label="Email" />
      <TextField source="profession" label="Профессия" />
      <TextField source="location" label="Локация" />
      
      {/* Навыки */}
      <FunctionField 
        label="Навыки" 
        render={(record: any) => record.skills?.slice(0, 3).join(', ') || 'Нет навыков'} 
      />
      
      {/* Telegram статус */}
      <BooleanField source="telegramLinked" label="Telegram" />
      <TextField source="telegramUsername" label="Telegram Username" />
      
      {/* 2FA статус */}
      <BooleanField source="twoFactorEnabled" label="2FA" />
      
      {/* Кошельки */}
      <TextField source="walletAddress" label="ETH кошелек" />
      <TextField source="tonWalletAddress" label="TON кошелек" />
      
      {/* Счетчики */}
      <TextField source="followersCount" label="Подписчики" />
      <TextField source="followingCount" label="Подписки" />
      
      <DateField source="createdAt" label="Дата регистрации" />
      
      <EditButton />
      <ShowButton />
      <DeleteButton />
    </Datagrid>
  </List>
);
